import {
  apiClient,
  getStoredAuth,
  resolveApiErrorMessage,
} from './authApi';

function withAuthHeaders() {
  const { accessToken } = getStoredAuth();

  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
  };
}

function withNoCacheHeaders() {
  return {
    ...withAuthHeaders(),
    'Cache-Control': 'no-cache, no-store, max-age=0',
    Pragma: 'no-cache',
    Expires: '0',
  };
}

export const reportsApi = {
  async listReports(options = {}) {
    const { bustCache = false } = options;
    const response = await apiClient.get('/reports', {
      headers: withNoCacheHeaders(),
      ...(bustCache ? { params: { _t: Date.now() } } : {}),
    });

    return response.data;
  },
};

export function resolveReportsApiError(error) {
  return resolveApiErrorMessage(error, 'Failed to process reports request.');
}

